import { useEffect } from "react";
import * as api from "../../api";

const EVENTS = ["pointerdown", "keydown", "touchstart", "wheel", "scroll"];
const MIN_GAP_MS = 60_000;

/** Envía un heartbeat al backend SÓLO cuando el admin interactúa de verdad con el panel
 *  (nunca por polling automático). Máximo un ping por minuto. */
export function useAdminActivity(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;
    let last = 0;
    let pending = false;
    const ping = () => {
      const now = Date.now();
      if (pending || now - last < MIN_GAP_MS || document.visibilityState === "hidden") return;
      pending = true;
      api.adminActivityPing()
        .then(() => { last = Date.now(); })
        .catch(() => {})
        .finally(() => { pending = false; });
    };
    ping();
    EVENTS.forEach((ev) => window.addEventListener(ev, ping, { passive: true }));
    return () => EVENTS.forEach((ev) => window.removeEventListener(ev, ping));
  }, [enabled]);
}
